import { createClient } from '@lumi.new/sdk'

export const lumi = createClient({
  projectId: 'p447410606447874048',
  apiBaseUrl: 'https://api.lumi.new',
  authOrigin: 'https://auth.lumi.new',
})
